<template>
  <van-tabbar
    v-if="visible"
    v-model="active"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    style="border-top: 1px solid #ebeef5"
  >
    <van-tabbar-item
      to="/dashboard"
      name="dashboard"
      icon="wap-home-o"
      @click="handleClick('/dashboard')"
    >
      <span>首页</span>
    </van-tabbar-item>
    <van-tabbar-item
      to="/service"
      name="service"
      icon="apps-o"
      @click="handleClick('/service')"
    >
      <span>业务</span>
    </van-tabbar-item>
    <van-tabbar-item
      to="/report"
      name="report"
      icon="description"
      @click="handleClick('/report')"
    >
      <span>报表</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from "vuex";
import checkPermission from "@/utils/permission";

export default {
  name: "Footer",
  components: {},
  props: {
    show: {
      // 显示与否
      type: Boolean,
      default: true,
    },
    value: {
      // 通过v-model绑定current值
      type: String,
      default: "dashboard",
    },
    activeColor: {
      // 激活时的演示，包括字体图标，提示文字等的演示
      type: String,
      default: "#E98F36",
    },
    inactiveColor: {
      // 未激活时的颜色
      type: String,
      default: "#c8c9cc",
    },
    beforeSwitch: {
      // 切换前的回调
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      visible: true,
      active: this.value,
    };
  },
  computed: {
    ...mapGetters({
      personType: "user/personType",
    }),
  },
  watch: {
    show(val) {
      this.visible = val;
    },
  },
  beforeCreate() {},
  created() {
    this.active = this.$route.path.replace(/\//g, "|").split("|")[1];
    if (this.personType === 0 || this.personType === 3) {
      this.visible = false;
    }
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClick(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="scss">
.van-tabbar {
  height: 8vh;
  font-size: 2vw;
}
</style>
